export default __webpack_public_path__ + "static/media/IMG_1361.9422f5e0.jpg";